import { identity } from 'lodash';
import { createDeepSelector } from '../../../../utils/milanoteReselect/milanoteReselect';
import { CellSelections } from '../../../../../common/table/TableTypes';
import { ActiveTableSelector } from '../hotTableStoreHooks';
import { ActiveTableObject } from '../hotTableStoreTypes';
import { getHotTableCellBackgroundColor } from '../../utils/hotInstanceUtils/hotTableCellMetaUtils';

export const selectActiveTableCellSelection = createDeepSelector<
    ActiveTableObject | undefined,
    unknown,
    CellSelections | undefined
>(
    // It's important that we get the selection state here, rather than in the return function, otherwise
    //  if we just pass through the activeTableState, the selector will not re-run, because the table instance reference
    //  is stable.
    (activeTableState) => activeTableState?.instance?.getSelected(),
    identity,
);

/**
 * Get the background colour of the current cell selection.
 */
export const selectActiveTableCurrentCellBackgroundColor: ActiveTableSelector<string | null | undefined> = (
    activeTable,
) => {
    const currentSelection = selectActiveTableCellSelection(activeTable);
    return getHotTableCellBackgroundColor(activeTable?.instance, currentSelection);
};
